import React from "react";
import { useIntl } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";

const AddressHeader = ({ edit }) => {
  const intl = useIntl();
  return (
    <TableHeader
      title={
        edit
          ? intl.formatMessage({
              id: "customer.edit",
              defaultMessage: "Editace zákazníka",
            })
          : intl.formatMessage({
              id: "customer.add",
              defaultMessage: "Nový zákazník",
            })
      }
    />
  );
};

export default AddressHeader;
